module.exports = __webpack_public_path__ + "static/media/money-bold.46d798fa.svg";